import {
    LicensePricingType,
    LicenseVariablePriceByType,
    PlatformLicenseEmployeeCountingType
} from '@iota/iota-management-portal-v4-client';
import { PlatformLicenseEntity, PlatformLicensePricingEntity } from 'src/app/store/entity-models';

export type PlatformLicenseProperties = Partial<Record<keyof PlatformLicenseEntity, string>>;
export const PlatformLicenseKeyLabels: Required<PlatformLicenseProperties> = {
    licenseNameAttribute: $localize`Name Attribute`,
    description: $localize`Description`,
    platformLicenseId: $localize`License ID`,
    licensePricingType: $localize`Pricing type`,
    licenseVariablePriceBy: $localize`Employee calculation`,
    employeeCountingType: $localize`Scale price calculation`,

    generalPricings: $localize`Pricings`,
    pricings: $localize`Pricings (including company-specific ones)`,
    attributes: $localize`Attributes`,

    creationBy: $localize`Created by`,
    creationById: $localize`Created by ID`,
    creationDateTime: $localize`Creation date`,
    modificationBy: $localize`Modification by`,
    modificationById: $localize`Modification by ID`,
    modificationDateTime: $localize`Modification date`,
    validFrom: $localize`Valid from`,
    validTo: $localize`Valid to`,
    skId: $localize`SK-ID`,

    currentlyEffectivePricing: $localize`Currently effective pricing`,
    currentlyEffectivePricingPriceMonthly: $localize`Price monthly`,
    currentlyEffectivePricingPriceYearly: $localize`Price yearly`,
    licensePricingTypeLabel: $localize`Pricing type`,
    licenseVariablePriceBasedOnLabel: $localize`Price based on`,
    businessPartnersThatUseOrOverrideThisLicenseLoaded: $localize`Business partners that use or override this license loaded`,
    businessPartnersThatUseOrOverrideThisLicense: $localize`Business partners that use or override this license`
};

export type PlatformLicensePricingProperties = Partial<Record<keyof PlatformLicensePricingEntity, string>>;
export const PlatformLicensePricingLabels: Required<PlatformLicensePricingProperties> = {
    platformLicenseActivationId: $localize`Platform license activation ID`,
    platformLicenseId: $localize`License ID`,
    platformLicensePricingId: $localize`LicensePricing ID`,

    priceIntervalsPerUser: $localize`Price intervals by user`,

    effectiveFrom: $localize`Effective from`,
    effectiveTo: $localize`Effective to`,

    internalDescription: $localize`Internal description`,
    licensePriceMonthly: $localize`Price monthly`,
    licensePriceYearly: $localize`Price yearly`,
    licenseSalesTax: $localize`Sales tax`,

    creationBy: $localize`Created by`,
    creationById: $localize`Created by ID`,
    creationDateTime: $localize`Creation date`,
    modificationBy: $localize`Modification by`,
    modificationById: $localize`Modification by ID`,
    modificationDateTime: $localize`Modification date`,
    validFrom: $localize`Valid from`,
    validTo: $localize`Valid to`,
    skId: $localize`SK-ID`,

    canBeDeleted: $localize`Can be deleted`
};

export const PlatformLicenseVariablePriceByLabels: Record<LicenseVariablePriceByType, string> = {
    ALL_EMPLOYEE: $localize`All employees`,
    REGISTERED_EMPLOYEE: $localize`Registered employees`
};
export const PlatformLicensePricingTypeLabels: Record<LicensePricingType, string> = {
    VOLUME_LICENSE: $localize`Volume license`,
    SCALE_PRICE_LICENSE: $localize`Scale priced license`,
    SINGLE_USER_LICENSE: $localize`Single user license`
};
export const PlatformLicenseEmployeeCountingTypeLabels: Record<PlatformLicenseEmployeeCountingType, string> = {
    COUNT_ACROSS_EMPLOYEE_GROUPS: $localize`Apply scale pricing to customer`,
    COUNT_PER_EMPLOYEE_GROUP: $localize`Apply scale pricing to employee groups`
};

export const PlatformLicenseKeySuffixes: PlatformLicenseProperties = {
    currentlyEffectivePricingPriceMonthly: ' €',
    currentlyEffectivePricingPriceYearly: ' €'
};

export const PLATFORM_LICENSE_OVERVIEW_IDS: (keyof PlatformLicenseProperties)[] = ['platformLicenseId'];
export const PLATFORM_LICENSE_DATE_PROPERTIES: (keyof PlatformLicenseProperties)[] = [
    'creationDateTime',
    'modificationDateTime',
    'validFrom',
    'validTo'
];
export const PLATFORM_LICENSE_TABLE_HEADERS: (keyof PlatformLicenseProperties)[] = [
    'licenseNameAttribute',
    'description',
    'licensePricingTypeLabel',
    'licenseVariablePriceBasedOnLabel',
    'currentlyEffectivePricingPriceMonthly',
    'currentlyEffectivePricingPriceYearly'
];

export const COMPANY_PLATFORM_LICENSE_TABLE_HEADERS: (keyof PlatformLicenseProperties)[] = [
    'licenseNameAttribute',
    'description',
    'licensePricingTypeLabel',
    'licenseVariablePriceBasedOnLabel',
    'currentlyEffectivePricingPriceMonthly',
    'currentlyEffectivePricingPriceYearly'
];

export const PLATFORM_LICENSE_PROPERTIES_WITH_CURRENCY: (keyof PlatformLicenseProperties)[] = [
    'currentlyEffectivePricingPriceMonthly',
    'currentlyEffectivePricingPriceYearly'
];
